import { type AfterViewInit, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { PartnerThemeContext } from ':core/context/partner-theme.context';
import { environment } from ':environments/environment';
import { RestaurantLogoFooterComponent } from ':modules/restaurant-logo-footer/restaurant-logo-footer.component';
import { GlobalHeaderComponent } from ':shared/components/global-header/global-header.component';
import { GlobalInformationBannerComponent } from ':shared/components/global-information-banner/global-information-banner.component';
import { ToastComponent } from ':shared/components/toast/toast.component';
import { OtherLocalStorageKey } from ':shared/enums';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, GlobalHeaderComponent, RestaurantLogoFooterComponent, ToastComponent, GlobalInformationBannerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
    readonly title = 'app-maloupe';

    private readonly _partnerThemeContext = inject(PartnerThemeContext);

    protected readonly backgroundImageStyle = computed<string | null>(() => {
        const bg = this._partnerThemeContext.activeTheme()?.background;
        return bg?.type === 'image' ? `url('${bg.value}')` : null;
    });

    protected readonly backgroundColorStyle = computed<string | null>(() => {
        const bg = this._partnerThemeContext.activeTheme()?.background;
        return bg?.type === 'color' ? bg.value : null;
    });

    protected readonly partnerTheme = this._partnerThemeContext.activeTheme;

    ngAfterViewInit(): void {
        this._initGoogleMapsScript();
    }

    private _initGoogleMapsScript(): void {
        const localStorageLang = localStorage.getItem(OtherLocalStorageKey.LANG);
        let scriptUrl = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${environment.GOOGLE_FRONTEND_KEY}`;
        // If we don't specify a language, it will try to detect the language from the browser or fall back to English
        if (localStorageLang) {
            scriptUrl += `&language=${localStorageLang}`;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptUrl;
        const head = document.getElementsByTagName('head');
        if (head) {
            document.body.appendChild(script);
            document.body.removeChild(script);
        }
    }
}
